import { create } from "../../../common/utils/zustand_state_manager";
import { ITerceirizacaoService } from "../../../features/terceirizacao/data/services/terceirizacao_service";
import { TerceirizacaoService } from "../../../features/terceirizacao/data/services/terceirizacao_service_impl";

//diarioObraService
type State = {
  terceirizacaoService: ITerceirizacaoService;
};

export const useTerceirizacaoServices = create<State>((set, get) => ({
  terceirizacaoService: new TerceirizacaoService(),
}));
